import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import Input from './Input'

const PasswordInput = ({ label, name, rules, placeholder = "" }) => {
    const [showPassword, setShowPassword] = useState()

    return (
        <Input
            label={label}
            name={name}
            rules={rules}
            type={showPassword ? "text" : "password"}
            rightElement={<Button size={"sm"} variant={"light"} onClick={() => setShowPassword(!showPassword)}>{showPassword ? <FaEyeSlash /> : <FaEye />}</Button>}
        />
    );
};

export default PasswordInput;